import React, {Dispatch, SetStateAction, useState} from 'react';
import CustomModal from "../CustomModal/CustomModal";
import styles from "../../ContactUsForm/ContactUsForm.module.css";
import MyBtn from "../MyBtn/MyBtn";
import {Formik} from "formik";
import {sendContactFormData} from "../../../store/reducers/ActionCreators";
import {setDisabled} from "../../../store/reducers/UserSlice";
import s from "../../../pages/PersonalAccount/PersonalAccount.module.css";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import MyInput from "../MyInput/MyInput";
import MyTextarea from "../MyTextarea/MyTextarea";
import TransparentButton from "../TransparentButton/TransparentButton";
import Icon from "@ant-design/icons";
import * as yup from "yup";
import {subjectThemes} from "../../../Constants/StaticData";
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import {ReactComponent as Back} from "../../../assets/img/personalAccount/back.svg";
import icon_info from '../../../assets/img/personalAccount/info-circle.svg'

type PropsType = {
    setIsModalOpen: Dispatch<SetStateAction<boolean | null>>
    isModalOpen: boolean | null
}

const validationSchema = yup.object({
    subject: yup.string().required('Required field'),
    message: yup.string().required('Required field').max(1000, 'max 1000 symbols'),
})

const CustomModalContactContainer = (props: PropsType) => {

    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean | null>(false)
    const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean | null>(false)
    const clientEmail: string | null = useAppSelector(state => state.userReducer.user.userData.email)
    const firstName: string | null = useAppSelector(state => state.userReducer.user.userData.firstName)
    const lastName: string | null = useAppSelector(state => state.userReducer.user.userData.lastName)
    const dispatch = useAppDispatch()

    return (
        <>

            <CustomModal setIsModalOpen={setIsSuccessModalOpen} isModalOpen={isSuccessModalOpen} isNotify>
                <div className={styles.flex_modal}>
                    <div className={styles.modal_text}>
                        <span className={styles.modal_success}>Success! </span>
                        Your request has been sent.
                    </div>
                    <div className={styles.modal_button}>
                        <MyBtn isPersonalAccountBtn title={"Ok"} onClick={() => setIsSuccessModalOpen(false)}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal setIsModalOpen={setIsErrorModalOpen} isModalOpen={isErrorModalOpen} isNotify> 
                <div className={styles.flex_modal}>
                    <div className={styles.modal_text}>
                        <span className={styles.modal_error}>Failed! </span>
                        Your request hasn’t been sent. Please try again or contact us.
                    </div>
                    <div className={styles.modal_button}>
                        <MyBtn isPersonalAccountBtn buttonType={"error"} title={"Ok"} onClick={() => setIsSuccessModalOpen(false)}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal setIsModalOpen={props.setIsModalOpen} isModalOpen={props.isModalOpen} type={"info"}>
                <Formik initialValues={{
                    subject: '',
                    message: '',
                    email: clientEmail,
                    name: `${firstName} ${lastName}`,
                }}
                        validationSchema={validationSchema}
                        onSubmit={(values) => {
                            dispatch(sendContactFormData(values))
                                .then((res) => {
                                    props.setIsModalOpen(false)
                                    setIsSuccessModalOpen(true)
                                })
                                .catch((e) => {
                                    props.setIsModalOpen(false)
                                    setIsErrorModalOpen(true)
                                })
                                .finally(() => {
                                    dispatch(setDisabled(false))
                                })
                        }}>
                    {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleSubmit
                      }) => (
                        <form onSubmit={handleSubmit} className={s.contact_form}>
                            <div>
                                <img src={icon_info} alt=""/>
                            </div>
                            <div className={s.modal_title}>
                                Write a message
                            </div>
                            <div className={s.subject_block}>
                                <div className={s.subject_title}>* subject of the message</div>
                                <CustomDropdown items={subjectThemes} id={"subject"} name={"subject"}/>
                                {
                                    errors.subject && <div className={s.error}>{errors.subject}</div>
                                }
                            </div>
                            <div className={s.message_block}>
                                <span>* Message text</span>
                                <MyTextarea
                                    id={"message"}
                                    name={"message"}
                                    value={values.message}
                                    onChange={handleChange}
                                />
                                {
                                    touched.message && errors.message &&
                                    <div className={s.error}>{errors.message}</div>
                                }
                            </div>
                            <div className={s.buttons_wrapper}>
                                <div className={s.button_block}>
                                    <TransparentButton
                                        title={"Cancel"}
                                        isPersonalAccountBtn
                                        buttonType={'info'}
                                        medium
                                        onClick={() => props.setIsModalOpen(false)}
                                    />
                                </div>
                                <div className={s.button_block}>
                                    <MyBtn title={"Send"} isPersonalAccountBtn medium buttonType={'confirm'}/>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            </CustomModal>

        </>
    );
};

export default CustomModalContactContainer;
